import { Pipe, PipeTransform } from '@angular/core'

@Pipe({ name: 'centsToDollars' })
export class CentsToDollarsPipePipe implements PipeTransform {
  transform(value: number): any {
    return value / 100
  }
}
